import { Dispatch, SetStateAction } from "react";
import { IProdutoPainelImplantacao } from "../../../../Interfaces/Vendas/PainelImplantacao/PainelImplantacaoInterface";
import { formatMoneyReais } from "../../../../Tools/FormatTools";

interface IModalDetalheProdutoProps {
    produto: IProdutoPainelImplantacao;
    setShow: Dispatch<SetStateAction<boolean>>;
}

export default function ModalDetalheProduto(props: IModalDetalheProdutoProps) {
    return (
        <div>
            <header className="ml-5">
                <h3>Detalhes do Produto: {props.produto.DS_PRODUTO}</h3>
            </header>
            <hr />
            <main className="modalProdutoBody">
                <div className="d-flex justify-content-between">
                    <h5>Descrição:</h5>
                    <span>{props.produto.DS_PRODUTO}</span>
                </div>
                <div className="d-flex justify-content-between">
                    <h5>Status:</h5>
                    <span>{props.produto.DS_STATUS}</span>
                </div>
                <div className="d-flex justify-content-between">
                    <h5>Mirror:</h5>
                    <span>
                        {props.produto.FL_MIRROR ? (
                            <span>Sim</span>
                        ) : (
                            <span>Não</span>
                        )}
                    </span>
                </div>
                <div className="d-flex justify-content-between">
                    <h5>Metros Quadrados:</h5>
                    <span>{props.produto.VL_METROS_QUADRADOS}</span>
                </div>
                <div className="d-flex justify-content-between">
                    <h5>Fração Ideal:</h5>
                    <span>{props.produto.VL_FRACAO_IDEAL}</span>
                </div>
                <div className="d-flex justify-content-between">
                    <h5>Chave ERP:</h5>
                    <span>{props.produto.ID_CHAVE_ERP}</span>
                </div>
                {props.produto.DS_RESERVA && (
                    <div className="d-flex justify-content-between">
                        <h5>Descrição Reserva:</h5>
                        <span>{props.produto.DS_RESERVA}</span>
                    </div>
                )}
                <div className="d-flex justify-content-between">
                    <h5>Preço:</h5>
                    <span>{formatMoneyReais(props.produto.VL_PRECO)}</span>
                </div>
            </main>
            <hr />
            <footer className="d-flex justify-content-end g-2 mr-2 flex-wrap align-items-center">
                {/* <button className="btn btn-outline-primary mr-5 w-130px">
                    Visualizar Preço
                </button>
                <button className="btn btn-outline-info mr-5 w-130px">
                    Reservar
                </button> */}
                <button
                    onClick={() => props.setShow(false)}
                    className="btn btn-outline-success mr-5 w-130px"
                >
                    Fechar
                </button>
            </footer>
        </div>
    );
}
